var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2615 -13380)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(665 104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.894,23.873H4.1V18.082L0,13.979l4.1-4.1V4.1H9.876l4.1-4.1,4.1,4.1h5.79v5.79l4.086,4.086-4.086,4.086v5.808H18.065l-4.086,4.086Z",
    transform: "translate(1954 13280)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.713,14.361A7.219,7.219,0,0,1,0,13.34,8.558,8.558,0,0,0,4.534,5.793,8.53,8.53,0,0,0,2.377.123,7.323,7.323,0,0,1,3.713,0,7.219,7.219,0,0,1,8.819,2.1a7.154,7.154,0,0,1,1.547,2.282,7.167,7.167,0,0,1,0,5.59,7.155,7.155,0,0,1-1.547,2.282,7.219,7.219,0,0,1-5.106,2.1Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 1964.027, 13287.113)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(2615 13380)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme);
export default __webpack_public_path__ + "static/media/theme.2a835326.svg";
export { ForwardRef as ReactComponent };